import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import './ProcessSection.scss';

function ProcessSection({ phase, title, label, body, outputs, image, index }) {
  const prefersReducedMotion = useReducedMotion();
  const shouldAnimate = !prefersReducedMotion;

  return (
    <section className="process-section" aria-labelledby={`phase-${phase}`}>
      <motion.div
        className="process-section__inner"
        initial={shouldAnimate ? { opacity: 0, y: 40 } : false}
        whileInView={shouldAnimate ? { opacity: 1, y: 0 } : undefined}
        transition={
          shouldAnimate
            ? {
                duration: 0.75,
                ease: 'easeOut',
                delay: Math.min(index * 0.04, 0.2),
              }
            : undefined
        }
        viewport={{ once: true, amount: 0.2 }}
      >
        <div className="process-section__left">
          <span className="process-section__phase">{phase}</span>
          <h2 id={`phase-${phase}`} className="process-section__title">
            {title}
          </h2>
          <p className="process-section__label">{label}</p>
        </div>

        <div className="process-section__right">
          <p className="process-section__body">{body}</p>

          <ul className="process-section__outputs">
            {outputs.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        {image && (
          <div
            className="process-section__media"
            style={{ backgroundImage: `url(${image})` }}
            aria-hidden="true"
          />
        )}
      </motion.div>
    </section>
  );
}

export default ProcessSection;
